import cache from '@/utils/cache'

const state = {
  favorites: [],
}
const getters = {
  listAllFavorites: (state) => {
    return state.favorites
  },
}
const mutations = {
  ADD_FAVORITE: (state, payload) => {
    state.favorites.push({
      id: uuidv4(),
      name: payload.name,
      frequency: payload.frequency,
      recherche: payload.recherche,
    })
  },
  // UPDATE_FAVORITE: (state, payload) => { },
  DELETE_FAVORITE: (state, payload) => {
    let index = state.favorites.find((f) => f.id === payload.id)
    state.favorites.splice(state.favorites.indexOf(index), 1)
  },
}
const actions = {
  addFavorite(context, payload) {
    cache.setItem('search_favorites', payload)
    context.commit('ADD_FAVORITE', payload)
  },
  // updateFavorite(context, payload) {
  //     context.commit('UPDATE_FAVORITE', payload)
  // },
  deleteFavorite(context, payload) {
    context.commit('DELETE_FAVORITE', payload)
  },
}

function uuidv4() {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    var r = (Math.random() * 16) | 0,
      v = c == 'x' ? r : (r & 0x3) | 0x8
    return v.toString(16)
  })
}

export default {
  state: state,
  getters: getters,
  mutations: mutations,
  actions: actions,
  modules: {},
  strict: true,
}
